import requestModule from '@/application/libs/requestModule'
import util from '@/application/libs/util'
import { t } from 'i18next'

//todo: make this Controller stateless
const context = {
    selectedUnitGroup: null,
    selectedUnit: null,
    selectedServicesByUnit: {},
    selectedUnits: []
};

const defaultColDef = {
    resizable: true, 
    lockVisible: true, 
    checkboxSelection: false, 
    editable: false,
    sortable: true,
    filter: true
};

const getSelectedUnits = function() {
    const selectedUnitsCopy = JSON.parse(JSON.stringify(context.selectedUnits));
    return Promise.resolve(selectedUnitsCopy);
};

const getSelectedServices = () => {
    const {selectedServicesByUnit, selectedUnit} = context;
    const selectedServices = selectedServicesByUnit[selectedUnit] || [];
    const selectedServicesCopy = JSON.parse(JSON.stringify(selectedServices));
    return Promise.resolve(selectedServicesCopy);
};

const getUnit = (USER_QUERY = null, MAX_RESULTS = 50) => {
    return requestModule.postRequest('getData', {
        FROM: "FILIAL_AUTOCOMPLETE",
        PARAMS: {
            CDOPERADOR: util.getLocalVar('userData').CDOPERADOR,
            CDGRUPFILI: context.selectedUnitGroup && context.selectedUnitGroup.CDGRUPFILI,
            USER_QUERY,
            MAX_RESULTS
        }
    }).then(response => {
        if(response.dataset && response.dataset.data){
            const data = response.dataset.data;
            return data.filter(d => !context.selectedUnits.some(el => el.CDFILIAL === d.CDFILIAL));
        } 
        return [];
    })
};

const getUnitGroup = () => {
    const { CDFILIAL } = util.getFilterInSession();
    return requestModule.postRequest('getData', {
        FROM: "AGUPAMENTO_FILIAL",
        PARAMS: { CDFILIAL }
    }).then(response => ((response.dataset && response.dataset.data) || []))
};

const getServiceData = (USER_QUERY = null, MAX_RESULTS = 25) => {
    return requestModule.postRequest('getData', {
        FROM: "SERVICO_AUTOCOMPLETE_DEFAULTCARD_DATA",
        PARAMS: {
            CDFILIAL: context.selectedUnit,
            DTREFCUSPADR: util.getFilterInSession().DTMESCARD,
            USER_QUERY,
            MAX_RESULTS
        }
    }).then(response => {
        if(response.dataset && response.dataset.data){
            const data = response.dataset.data;
            const servicesInCurrentUnit = context.selectedServicesByUnit[context.selectedUnit] || [];
            return data.filter(d => !servicesInCurrentUnit.some(el => el.CDSERVFILI === d.CDSERVFILI));
        } 
        return [];
    });
};

const getCostType = (v = '') => {
    return requestModule.postRequest('getData', {
        FROM: "TIPOCUSTO_SEARCH",
        PARAMS: {
            CDFILIAL: util.getFilterInSession().CDFILIAL,
            NMTIPOCUSTO: v
        }
    }).then(response=>response.dataset && response.dataset.data)       
};

const getFreezeData = ({CDSERVFILI, CDFILIAL}) => {
  return requestModule.postRequest('getData', {
        FROM: "PERMITECONGELAR",
        PARAMS: {
            CDFILIAL,
            CDSERVFILI,
            DTMESCARD: util.getFilterInSession().DTMESCARD
        }
    }).then(response=> response.dataset && response.dataset.data[0]);
};

const UnitGridConfig = {
    defaultColDef,
    columnDefs: [
        {   headerValueGetter: ()=> {return t('code') }, field: "CDFILIAL" },
        {   headerValueGetter: ()=> {return t('name') }, field: "NMFILIAL", cellEditor: "vSelectCellEditor",
            minWidth: 220,
            editable: ({data}) => data.__is_new_row,
            cellClass: ["select-350"],
            cellEditorParams: {
                optionsSearchFunction: getUnit,
                valueColumn: "CDFILIAL",
                labelColumn: "NMFILIAL",
                outDataColumns: ["CDFILIAL"],
                searchableColumns: ["CDFILIAL" , "NMFILIAL"]
            },
        }
    ],
    dataSource: getSelectedUnits,
    rowSelection: 'single'
};

const __getCostFromPercentage = (defaultCost, percentage, operation = "+") => {
    const operationMultipler = operation === "-" ? -1 : 1;
    defaultCost = parseFloat(defaultCost);
    percentage = parseFloat(percentage);
    return (defaultCost + (operationMultipler * defaultCost) * (percentage / 100));
};

const __getPercentageFromCost = (defaultCost, cost, invertOperation = false) => {
    const inversionMultiplier = invertOperation ? -1 : 1;
    defaultCost = parseFloat(defaultCost);
    cost = parseFloat(cost);
    return ( ( (inversionMultiplier * (defaultCost - cost)) * 100) / defaultCost);
}

const gridFieldFunctions = {
    NMSERVICO: async function(data){
        if(data.CDSERVFILI){
            data.DTREFECUSTO && (data.DTREFECUSTO = data.DTREFECUSTO.split(' ')[0]);
            data.PERC_CUSTO_MIN = !!data.PERC_CUSTO_MIN ? _getNumberFromBRString (data.PERC_CUSTO_MIN): 0;
            data.PERC_CUSTO_MAX = !!data.PERC_CUSTO_MAX ? _getNumberFromBRString (data.PERC_CUSTO_MAX): 0;
            !data.VLR_CONGELADO && (data.VLR_CONGELADO = 0);
            const freezeData = await getFreezeData({CDFILIAL: context.selectedUnit, CDSERVFILI: data.CDSERVFILI});
            data.freezeData = freezeData;
        }
    },
    PERC_CUSTO_MIN(data){
        const {VRCUSTPADR: defaultCost, PERC_CUSTO_MIN: minPercentage} = data;
        if(defaultCost && minPercentage){
            data.PERC_CUSTO_MIN = _getNumberFromBRString(minPercentage);
            const newCost = __getCostFromPercentage(defaultCost, minPercentage, '-');
            newCost && (data.VLR_CUSTO_MIN = newCost);
        }
    },
    PERC_CUSTO_MAX(data){
        const {VRCUSTPADR: defaultCost, PERC_CUSTO_MAX: maxPercentage} = data;
        if(defaultCost && maxPercentage){
            data.PERC_CUSTO_MAX = _getNumberFromBRString(maxPercentage);
            const newCost = __getCostFromPercentage(defaultCost, maxPercentage);
            newCost && (data.VLR_CUSTO_MAX = newCost);
        }
    },
    VLR_CUSTO_MIN(data){
        const {VRCUSTPADR: defaultCost, VLR_CUSTO_MIN: minCost} = data;
        if(defaultCost && minCost){
            data.VLR_CUSTO_MIN = _getNumberFromBRString(minCost);
            const newPercentage = __getPercentageFromCost(defaultCost, minCost);
            newPercentage && (data.PERC_CUSTO_MIN = newPercentage);
        }
    },
    VLR_CUSTO_MAX(data){
        const {VRCUSTPADR: defaultCost, VLR_CUSTO_MAX: maxCost} = data;
        if(defaultCost && maxCost){
            data.VLR_CUSTO_MAX = _getNumberFromBRString(maxCost);
            const newPercentage = __getPercentageFromCost(defaultCost, maxCost, true);
            newPercentage && (data.PERC_CUSTO_MAX = newPercentage);
        }
    },
    VLR_CONGELADO(data){
        data.VLR_CONGELADO = parseInt(data.VLR_CONGELADO) || 0;
    }
};

const _updateSelectedServiceData = (data, _fieldName) => {
    const validationResult = _validateServiceValues(data, data.freezeData);
    if(validationResult === null){
        const {selectedServicesByUnit, selectedUnit} = context;
        const key = data.CDSERVFILI;
        const services = selectedServicesByUnit[selectedUnit];
        const rowIndex = services.findIndex(s => s.CDSERVFILI === key);
        services[rowIndex] = data;
    } else {
        util.showErrorNotification({title: validationResult});
    }
    return ServiceGridConfig.reloadData();
};

const onServiceGridCellChange = async function({colDef, data}) {
    const fieldName = colDef.field;
    gridFieldFunctions[fieldName] && gridFieldFunctions[fieldName](data);
    if(!data.__is_new_row){
        _updateSelectedServiceData(data, fieldName).then(() => {
            ServiceGridConfig.advancedOptions.api.refreshCells();
        });
    }
    ServiceGridConfig.advancedOptions.api.refreshCells();
};


const ServiceGridConfig = {
    defaultColDef: {
        ...defaultColDef, 
        editable: true,
    },
    columnDefs: [
        { headerValueGetter: ()=> {return t('service') }, field: "NMSERVICO", cellEditor: "vSelectCellEditor",
            cellClass: ["select-350"],
            cellEditorParams: {
                optionsSearchFunction: getServiceData,
                valueColumn: "CDSERVFILI",
                labelColumn: "NMSERVICO",
                outDataColumns: ["CDSERVFILI", "CDTIPOCUSTO", "NMTIPOCUSTO", "VRCUSTPADR",
                "PERC_CUSTO_MIN", "PERC_CUSTO_MAX", "VLR_CUSTO_MIN", "VLR_CUSTO_MAX",
                "DTREFECUSTO"],
                searchableColumns: ["CDSERVFILI" , "NMSERVICO"]
            },
            editable: ({data}) => data.__is_new_row
        },
        { headerValueGetter: ()=> {return t('cost_type') }, field: "NMTIPOCUSTO", cellEditor: "vSelectCellEditor",
            cellClass: ["select-350"],
            cellEditorParams: {
                optionsSearchFunction: getCostType,
                valueColumn: "CDTIPOCUSTO",
                labelColumn: "NMTIPOCUSTO",
                outDataColumns: ["CDTIPOCUSTO"],
                searchableColumns: ["CDTIPOCUSTO" , "NMTIPOCUSTO"]
            },
        },
        { headerValueGetter: ()=> {return t('date') }, field: "DTREFECUSTO", cellEditor: "dateCellEditor"},
        { headerValueGetter: ()=> {return t('standard_cost') }, field: "VRCUSTPADR"},
        { headerValueGetter: ()=> {return t('minimum_percentage_simbol') }, field: "PERC_CUSTO_MIN"},
        { headerValueGetter: ()=> {return t('maximum_percentage_simbol') }, field: "PERC_CUSTO_MAX"},
        { headerValueGetter: ()=> {return t('minimum_value') }, field: "VLR_CUSTO_MIN"},
        { headerValueGetter: ()=> {return t('maximum_value') }, field: "VLR_CUSTO_MAX"},
        { headerValueGetter: ()=> {return t('frozen_days') }, field: "VLR_CONGELADO",
        editable: ({data}) => data.freezeData && data.freezeData.PERMITE_CONGELAR === 'S'},
    ],
    onCellValueChanged: onServiceGridCellChange,
    dataSource: getSelectedServices,
    rowSelection: 'single'
};

const _getNumberFromBRString = (numberString) => {
    numberString = numberString && numberString.replace(',', '.');
    if(numberString && numberString[0] === '.'){
        numberString = '0' + numberString; 
    }
    return numberString;
}; 

const _validateServiceValues = function(serviceData, freezeData) {
    let errorMessage = null;
    if(Object.keys(serviceData).some(k => serviceData[k]) === undefined){
        errorMessage = t('fill_in_all_fields');
    } 

    //number field validations
    const validateNumberValues = {
        "PERC_CUSTO_MIN": t('minimum_percentage'),
        "PERC_CUSTO_MAX": t('maximum_percentage'),
        "VLR_CUSTO_MIN": t('minimum_value'),
        "VLR_CUSTO_MAX": t('maximum_value')
    };
    Object.keys(validateNumberValues).forEach(colName => {
        const colValue = parseFloat(serviceData[colName]);
        const colLabel = validateNumberValues[colName];
        if(isNaN(colValue)){
            errorMessage = t('numericalInteger',{PARAM:`${colLabel}`});
        } else if(colValue < 0) {
            errorMessage = t('field_must_be_greater_than_zero', {PARAM: `${colLabel}` });
        }
    });

    // freeze validation
    const maxFreezableDays = parseInt(freezeData.LASTDAY);
    const freezeDays = parseInt(serviceData.VLR_CONGELADO);
    if(freezeDays < 0 || freezeDays > maxFreezableDays){
        errorMessage = t('range_frozen_days', {PARAM: `${maxFreezableDays}`});
    }
    return errorMessage;
};

const updateSelectedServices = function() {
    const {selectedServicesByUnit, selectedUnit} = context;
    const services = ServiceGridConfig.getRowData();
    const newRow = services.find(r => r.__is_new_row);

    const selectedUnitServices = selectedServicesByUnit[selectedUnit] || [];
    const formattedRow = {
        CDSERVFILI: newRow.CDSERVFILI_key || newRow.CDSERVFILI,
        CDSERVFILI: newRow.CDSERVFILI_key || newRow.CDSERVFILI,
        NMTIPOCUSTO: newRow.NMTIPOCUSTO,
        NMSERVICO: newRow.NMSERVICO,
        VRCUSTPADR: newRow.VRCUSTPADR,
        PERC_CUSTO_MIN: newRow.PERC_CUSTO_MIN,
        PERC_CUSTO_MAX: newRow.PERC_CUSTO_MAX,
        VLR_CUSTO_MIN: newRow.VLR_CUSTO_MIN,
        VLR_CUSTO_MAX: newRow.VLR_CUSTO_MAX,
        VLR_CONGELADO: newRow.VLR_CONGELADO,
        DTREFECUSTO: newRow.DTREFECUSTO,
        freezeData: newRow.freezeData
    };
    const errorMessage = _validateServiceValues(formattedRow, newRow.freezeData);
    if(!errorMessage){
        selectedUnitServices.unshift(formattedRow);
        selectedServicesByUnit[selectedUnit] = selectedUnitServices;
        ServiceGridConfig.reloadData();
        ServiceGridConfig.enableSelection();
    } else {
        util.showErrorNotification({title: errorMessage});
    }
};

const syncUnit = function() {
    // updateSelectedServices();
    const selectedUnit = UnitGridConfig.advancedOptions.api.getSelectedRows()[0];
    context.selectedUnit = selectedUnit.CDFILIAL;
    // context.selectedUnit = ;
    ServiceGridConfig.reloadData();
};

const addNewServiceRow = function() {
    if(context.selectedUnit){
        ServiceGridConfig.addNewRowToGrid();
    } else {
        util.showNotification({title: t('select_a_unit')});
    }
};

const saveUnit = function() {
    const unitData = UnitGridConfig.getRowData();
    const newRow = unitData.find(r => r.__is_new_row);
    if(newRow.CDFILIAL){
        const {CDFILIAL, NMFILIAL} = newRow;
        context.selectedUnits.unshift({CDFILIAL, NMFILIAL});
        UnitGridConfig.enableSelection();
        UnitGridConfig.reloadData().then(() => {
            UnitGridConfig.gridControl.rowModel.rowsToDisplay[0].setSelected(true);
        });
    } else {
        util.showErrorNotification({title: t('field_unit_is_required')});
    }
};

const removeServiceRow = function() {
    const rowToRemove = ServiceGridConfig.advancedOptions.api.getSelectedRows()[0];
    const {selectedUnit, selectedServicesByUnit} = context;
    const selectedServices = selectedServicesByUnit[selectedUnit];
    selectedServicesByUnit[selectedUnit] = selectedServices.filter(s => s.CDSERVFILI !== rowToRemove.CDSERVFILI);
    ServiceGridConfig.reloadData();
};

const removeUnit = function() {
    const {selectedUnit, selectedServicesByUnit} = context;
    delete selectedServicesByUnit[selectedUnit];
    context.selectedUnits = context.selectedUnits.filter(u => u.CDFILIAL !== selectedUnit);
    UnitGridConfig.reloadData();
    context.selectedUnit = null;
    ServiceGridConfig.reloadData();
};

export default {
    UnitGridConfig,
    ServiceGridConfig,
    syncUnit,
    addNewServiceRow,
    getUnitGroup,
    saveUnit,
    updateSelectedServices,
    removeServiceRow,
    removeUnit,

    setContextProp(propName, propValue){
        context[propName] = propValue;
    },
    clearContext(){
        context.selectedUnitGroup = null;
        context.selectedUnit = null;
        context.selectedServicesByUnit = {};
        context.selectedUnits = [];
    }
}